<template>
  <md-app md-waterfall class="handbook" md-mode="fixed" v-if="handbook.name">
    <md-app-toolbar class="md-primary" v-bind:style="headerStyle">
<div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <img :src="handbook.logo" class="header-logo"/><span class="md-title" v-bind:style="titleStyle">{{ this.handbook.name }}</span>
      </div>
      <div class="md-toolbar-section-end">
        <md-button v-bind:style="actionStyle" @click="sign">Sign</md-button>
      </div>
</div>
    </md-app-toolbar>
    <md-app-content ref="content" class="handbook-sections" v-bind:style="bodyStyle">
      <HandbookSections ref="sections"/>
    </md-app-content>
  </md-app>
</template>

<script>
import { mapState } from 'vuex'
import HandbookSections from '@/components/HandbookSections.vue'
export default{
  name: "Handbook",
  components: {
    HandbookSections
  },
  computed: {
    ...mapState({ 
      handbook: s => s.handbook.handbook,
      selectedSection: s => s.selectedSection
    }),
    headerStyle: function(){
      return {
        "background-color": this.handbook.header_color_hex
      }
    },
    actionStyle: function(){
      return {
        "background-color": this.handbook.action_color_hex
      }
    },
    titleStyle: function() {
      return {
        "color": this.handbook.header_text_color_hex ,
        "font-family": this.handbook.header_font
      }
    },
    bodyStyle: function() {
      return {
        "background-color": this.handbook.bg_color_hex,
        "font-family": this.handbook.body_font
      }
    }
  },
  methods: {
    sign(){this.$emit('signed')}
  },
  mounted() {
    this.$store.watch(
      (state, getters) => getters.selectedSection,
      (newSection) => {
        let offsetTop = this.$refs["sections"].scrollTo(newSection.id)
        this.$refs["content"].$el.parentElement.scrollTop = offsetTop
      })
  }
}
</script>
<style>
.header-logo {
  width: 48px;
}
.handbook{
  max-height: 100vh;
}
.handbook-sections{
  padding: 0 !important;
  height: auto !important;
}
</style>
